import * as React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SxProps,
} from '@mui/material';
import { useGlobalSettings } from '../../app/GlobalSettingProvider';

export const TimeZoneSelector = ({ sx }: { sx?: SxProps }) => {
  const { settings, setSettings } = useGlobalSettings();

  return (
    <FormControl
      id="timezone-selector"
      sx={{ backgroundColor: 'white', ...sx }}
    >
      <InputLabel id="timezone-select-label">Timezone</InputLabel>
      <Select
        size="small"
        fullWidth
        sx={{ width: '180px' }}
        labelId="timezone-select-label"
        label="timezone"
        id="timezone"
        value={settings.timeZone.current}
        onChange={(props) => {
          setSettings({
            ...settings,
            timeZone: {
              ...settings.timeZone,
              current: props.target.value,
            },
          });
        }}
      >
        {[settings.timeZone.userLocale, 'UTC'].map((item) => (
          <MenuItem key={item} value={item}>
            {item.replace('_', ' ')}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
